import "vue-router"

declare module "vue-router" {
  interface RouteMeta {
    permissions?: string[]
    // Auth strips the URL fragment (MSAL leftovers); set when the route carries data there.
    keepHash?: boolean
  }
}

export const RouteNames = {
  Home: "Home",
  Settings: "Settings",
  TariffQuoter: "TariffQuoter",
  Issues: "Issues",

  CustomerSearch: "CustomerSearch",
  CustomerOverview: "CustomerOverview",
  CustomerTimeline: "CustomerTimeline",
  CustomerFinancials: "CustomerFinancials",
  CustomerFinancialsTransactions: "CustomerFinancialsTransactions",
  CustomerFinancialsSpayg: "CustomerFinancialsSpayg",
  CustomerFinancialsSetUpPaymentPlan: "CustomerFinancialsSetUpPaymentPlan",
  CustomerRefundReview: "CustomerRefundReview",
  CustomerReviewPaymentAmount: "CustomerReviewPaymentAmount",
  CustomerIssueBill: "CustomerIssueBill",
  CustomerIssueBillCompleted: "CustomerIssueBillCompleted",
  CustomerIssueBillFailed: "CustomerIssueBillFailed",
  CustomerSetUpPaymentPlan: "CustomerSetUpPaymentPlan",
  CustomerMeterpoints: "CustomerMeterpoints",
  CustomerChangeOfTenancy: "CustomerChangeOfTenancy",
  CustomerChangeOfTenancyCompleted: "CustomerChangeOfTenancyCompleted",
  CustomerAgreements: "CustomerAgreements",
  CustomerComplaints: "CustomerComplaints",
  CustomerJunifer: "CustomerJunifer",
  CustomerRenewals: "CustomerRenewals",
  CustomerImbp: "CustomerImbp",
  CustomerImbpBooking: "CustomerImbpBooking",
  CustomerDeceased: "CustomerDeceased",
  CustomerOperationsIssues: "CustomerOperationsIssues",
  CustomerSmartDevices: "CustomerSmartDevices",
  CustomerSpayg: "CustomerSpayg",

  AuthFailed: "AuthFailed",

  AdminUserList: "AdminUserList",
  AdminUserEdit: "AdminUserEdit",
  AdminEnergyProducts: "AdminEnergyProducts",
  AdminDcaManagement: "AdminDcaManagement",
  AdminFeaturesAdmin: "AdminFeaturesAdmin",
  AdminConfigurations: "AdminConfigurations",
  AdminMaintenance: "AdminMaintenance",
  AdminEnrolments: "AdminEnrolments",
  AdminReferrals: "AdminReferrals",
  AdminReferralCode: "AdminReferralCode",
  AdminDirectDebitReviews: "AdminDirectDebitReviews",
  AdminSmartCharging: "AdminSmartCharging",
  AdminEmailVolumes: "AdminEmailVolumes",
  AdminEmailThrottles: "AdminEmailThrottles",
  AdminMarketingBanners: "AdminMarketingBanners",
  AdminSyncUsers: "AdminSyncUsers",
  MeterReadings: "MeterReadings",
  AdminSmartMeters: "AdminSmartMeters",
  AdminSmsSender: "AdminSmsSender",
  AdminTradingData: "AdminTradingData",
  AdminComplaints: "AdminComplaints",
  AdminCreditChecks: "AdminCreditChecks",
  AdminFreshdeskContacts: "AdminFreshdeskContacts",
  AdminFreshdeskTickets: "AdminFreshdeskTickets",
  AdminTestAccounts: "AdminTestAccounts",
  AdminNewsfeed: "AdminNewsfeed",
  AdminNewsfeedCreate: "AdminNewsfeedCreate",
  AdminNewsfeedEdit: "AdminNewsfeedEdit",
  AdminDrawList: "AdminDrawList",
  AdminDrawDetail: "AdminDrawDetail",
  AdminServices: "AdminServices",
  AdminServiceJobs: "AdminServiceJobs",
  AdminServiceConfig: "AdminServiceConfig",
  AdminServiceConfigDetail: "AdminServiceConfigDetail",
  AdminServiceWarrants: "AdminServiceWarrants",
  AdminServiceWarrantsDca: "AdminServiceWarrantsDca",
  AdminServiceWarrantsFiles: "AdminServiceWarrantsFiles",
  AdminServiceWarrantsCommunications: "AdminServiceWarrantsCommunications",
  AdminServiceWarrantsCommunicationGroup:
    "AdminServiceWarrantsCommunicationGroup",
  AdminEmailTemplates: "AdminEmailTemplates",
  AdminEmailTemplatesCreate: "AdminEmailTemplatesCreate",
  AdminEmailTemplatesDetail: "AdminEmailTemplatesDetail",
  AdminEmailTemplatesSync: "AdminEmailTemplatesSync",
  AdminEmailHeadlineImage: "AdminEmailHeadlineImage",
  AdminExternalEmailTemplateDetail: "AdminExternalEmailTemplateDetail",
} as const
